// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__1dpoe","buttons":"PendingPaymentAlert_buttons__Q6bVP"};